import React from 'react';
import styled, { keyframes } from 'styled-components';
import colors from 'theme/colors';

export default function CardSkeleton({ height = 200 }) {
    return (
        <SkeletonCard height={height}>
            <SkeletonLine width="40%" height="14px" />
            <SkeletonLine width="60%" height="10px" marginTop="8px" />
            <SkeletonBlock marginTop="20px" />
        </SkeletonCard>
    );
}

export function MiniCardSkeleton() {
    return (
        <SkeletonCard height={120}>
            <SkeletonRow>
                <SkeletonCircle />
                <SkeletonLine width="60%" height="12px" />
            </SkeletonRow>
            <SkeletonLine width="50%" height="24px" marginTop="12px" />
            <SkeletonLine width="30%" height="10px" marginTop="8px" />
        </SkeletonCard>
    );
}

export function KpiCardSkeleton({ gradient }) {
    return (
        <SkeletonKpiCard gradient={gradient}>
            <SkeletonLine width="50%" height="12px" opacity={0.3} />
            <SkeletonLine width="40%" height="28px" marginTop="8px" opacity={0.3} />
            <SkeletonLine width="30%" height="10px" marginTop="8px" opacity={0.3} />
        </SkeletonKpiCard>
    );
}

const shimmer = keyframes`
    0% { background-position: -200px 0; }
    100% { background-position: calc(200px + 100%) 0; }
`;

const SkeletonCard = styled.div`
    background: ${colors.neutralLight};
    border-radius: 12px;
    padding: 24px;
    box-shadow: 0 1px 8px ${colors.night}08;
    border: 1px solid ${colors.night}11;
    height: ${({ height }) => height}px;
    display: flex;
    flex-direction: column;
`;

const SkeletonKpiCard = styled.div`
    padding: 20px 24px;
    border-radius: 12px;
    background: ${({ gradient }) => gradient};
    display: flex;
    flex-direction: column;
`;

const SkeletonLine = styled.div`
    width: ${({ width }) => width || '100%'};
    height: ${({ height }) => height || '14px'};
    border-radius: 4px;
    margin-top: ${({ marginTop }) => marginTop || '0'};
    background: ${({ opacity }) => opacity
        ? `rgba(255, 255, 255, ${opacity})`
        : '#e8e8ef'};
    background-image: ${({ opacity }) => opacity
        ? `linear-gradient(90deg, rgba(255,255,255,${opacity}) 0px, rgba(255,255,255,${opacity + 0.15}) 40px, rgba(255,255,255,${opacity}) 80px)`
        : 'linear-gradient(90deg, #e8e8ef 0px, #f5f5f5 40px, #e8e8ef 80px)'};
    background-size: 200px 100%;
    animation: ${shimmer} 1.4s ease-in-out infinite;
`;

const SkeletonBlock = styled.div`
    flex: 1;
    border-radius: 6px;
    margin-top: ${({ marginTop }) => marginTop || '0'};
    background: #e8e8ef;
    background-image: linear-gradient(90deg, #e8e8ef 0px, #f5f5f5 40px, #e8e8ef 80px);
    background-size: 200px 100%;
    animation: ${shimmer} 1.4s ease-in-out infinite;
`;

const SkeletonRow = styled.div`
    display: flex;
    align-items: center;
    gap: 10px;
`;

const SkeletonCircle = styled.div`
    width: 36px;
    height: 36px;
    border-radius: 8px;
    background: #e8e8ef;
    background-image: linear-gradient(90deg, #e8e8ef 0px, #f5f5f5 40px, #e8e8ef 80px);
    background-size: 200px 100%;
    animation: ${shimmer} 1.4s ease-in-out infinite;
    flex-shrink: 0;
`;
